var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 320,
    viewBox: "0 0 640 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.877 165.825C362.067 166.538 348.515 170.467 348.515 184.806C348.515 194.089 355.93 204.153 374.754 204.153C399.99 204.153 413.462 190.423 413.462 167.903L413.463 165.426C404.616 165.426 393.704 165.503 383.877 165.825ZM437.518 195.578C437.518 202.565 437.72 209.462 438.331 215.672H415.956C415.36 210.558 415.142 205.477 415.142 200.548C403.045 215.391 388.657 219.658 368.696 219.658C339.091 219.658 323.24 204.039 323.24 185.973C323.24 159.809 344.799 150.584 382.227 149.728C392.462 149.494 403.959 149.46 413.463 149.46L413.462 146.903C413.462 129.387 402.209 122.185 382.709 122.185C368.233 122.185 357.564 128.164 356.465 138.497H331.192C333.866 112.735 360.984 106.219 384.827 106.219C413.391 106.219 437.518 116.363 437.518 146.519L437.518 195.578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.825 153.048C174.892 130.59 158.651 122.185 141.294 122.185C122.576 122.185 107.633 131.639 105.015 153.048H175.825ZM104.497 169.014C105.795 190.806 120.85 203.694 141.551 203.694C155.894 203.694 168.652 197.861 172.924 185.172H197.732C192.907 210.918 165.498 219.658 141.907 219.658C99.0111 219.658 80 196.078 80 164.279C80 129.274 99.6635 106.219 142.298 106.219C176.234 106.219 201.098 123.946 201.098 162.636V169.014H104.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.799 203.238C285.154 203.238 300.451 187.178 300.451 162.941C300.451 138.708 285.154 122.645 262.799 122.645C240.57 122.645 225.146 138.708 225.146 162.941C225.146 187.178 240.57 203.238 262.799 203.238ZM201.097 64H225.146L225.144 124.308C236.931 110.289 253.17 106.219 269.155 106.219C295.956 106.219 325.724 124.27 325.724 163.246C325.724 195.883 302.049 219.658 268.709 219.658C251.257 219.658 234.83 213.409 224.699 201.029C224.699 205.974 224.422 210.957 223.881 215.672H200.278C200.689 208.05 201.097 198.559 201.097 190.88L201.097 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 110.213L485.627 256H458.696L480.078 215.518L424.107 110.213H452.248L493.434 192.489L534.505 110.213H560Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 192,
    fill: "white",
    transform: "translate(80 64)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEy);
export default __webpack_public_path__ + "static/media/ey.eeafec999d2e103c35db184a33bce44f.svg";
export { ForwardRef as ReactComponent };